import { makeStyles, Theme } from "@material-ui/core/styles";

const TableStyle = makeStyles((theme: Theme) => ({
    root: {
        position: "relative",
        minHeight: "150px"
    },
    table: {
        margin: theme.spacing(4, 0, 4)
    },
    header: {
        backgroundColor: theme.palette.primary.main
    },
    headerCell: {
        fontSize: "1.3rem",
        padding: theme.spacing(4, 4, 4, 2),
        color: theme.palette.primary.contrastText
    },
    tableCellIcon: {
        [theme.breakpoints.down("xs")]: {
            padding: "0px"
        }
    },
    button: {
        margin: theme.spacing(1),
        padding: theme.spacing(2),
        borderRadius: "8px",
        "&:hover": {
            backgroundColor: theme.palette.secondary.main
        }
    },
    icon: {
        cursor: "pointer"
    },
    row: {},
    input: {
        display: "none"
    },
    message: {
        padding: theme.spacing(4),
        color: theme.palette.secondary.dark
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(4)
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "2px solid #000",
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3)
    }
    // modalButton: {
    //     position: "absolute",
    //     right: theme.spacing(4),
    //     top: theme.spacing(4)
    // }
}));

export default TableStyle;
